module.exports = __webpack_public_path__ + "img/3valvulas.a88856ca.jpg";